<template>
  <el-menu class="desktop-products-column" mode="vertical" :router="true">
    <el-menu-item class="desktop-products-column__header"
      :route="{ name: 'Products', params: { category: category.slug } }" :index="`products-${category.id}-all`"
      :disabled="isCurrentRoute">
      <div class="vertically-center">{{ category.title }}</div>
    </el-menu-item>
    <nav-desktop-products-submenu v-for="(category1, key1) in category.children" :key="key1"
      :index-prefix="`${indexPrefix}-c${key1}`" :category="category1" :expanded-category="expandedCategoryId"
      @expansionChanged="(category) => { expandedCategoryId = (category) ? category.id : null }">
    </nav-desktop-products-submenu>
    <el-menu-item v-if="!expandedCategoryId" :route="{ name: 'Products', params: { category: category.slug } }"
      :index="`products-${category.id}-all`" :disabled="isCurrentRoute">
      {{ $t('seeAll {category}', { category: category.title }) }}
      <i class="el-submenu__icon-arrow el-icon-arrow-right"></i>
    </el-menu-item>
  </el-menu>
</template>

<script>
import mixins from '@/mixins';
import router from '@/router';
import NavDesktopProductsSubmenu from './NavDesktopProductsSubmenu.vue';

export default {
  name: 'NavDesktopProductsColumn',
  mixins: [
    mixins.supportedFeatures
  ],
  props: {
    category: {
      type: Object,
      required: true,
    },
    indexPrefix: {
      type: String,
      required: true,
    }
  },
  data: () => {
    return {
      isCurrentRoute: false,
      expandedCategoryId: null,
    };
  },
  watch: {
    '$route'(to, from) {
      this.isCurrentRoute = to.name === 'Products' && to.params.category === this.category.slug;
    }
  },
  components: {
    NavDesktopProductsSubmenu
  },
}
</script>

<style lang="scss" scoped="true">
@import '@/assets/base/_variables.scss';
@import '@/assets/base/_typography.scss';
@import 'element-theme-chalk/src/mixins/mixins.scss';

.desktop-products-column {
  // Five columns that adapt as needed
  flex: 0 1 20%;
  position: static;
  border-right: none;
  min-height: 60vh;
  overflow-y: scroll;

  :deep(.el-menu-item) {
    @extend h4;
    font-size: 18px;
    border-bottom: 1px solid $--color-grayscale-2;
    // !important because of element-ui style tag
    padding: 1.25rem 30px 1.25rem .25rem !important;
    font-weight: bold;
    color: $--color-menu-gray;
    white-space: normal;
    height: auto;

    &.second-level-product {
      padding-left: 10px !important;
    }

    &:hover,
    &:active {
      color: $--color-secondary;
    }

    &>.el-icon-arrow-right {
      color: $--color-primary;
      font-size: 30px;
      margin-top: -16px;
      right: 5px;
    }

    @include res(md) {
      font-size: 18px;
    }

    @include res(lg) {
      font-size: 18px;
    }
  }

  :deep(.desktop-products-column__header) {
    @extend h4;
    font-size: 20px;
    font-weight: 900;
    text-transform: uppercase;
    color: $--color-white;
    background-color: $--color-secondary;
    text-align: center;
    // !important because of element-ui style tag
    padding: 10px !important;
    height: 73px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-content: center;

    &.is-active {
      color: $--color-white !important;
    }

    &.is-disabled {
      opacity: 1 !important;
      color: $--color-white !important;
      background-color: $--color-secondary !important;
      text-decoration: underline;
    }

    &:active {
      color: $--color-white;
    }

    @include res(lg) {
      // Copied because the following is not allowed
      // @extend h3;
      font-size: 22px;
      line-height: 34px;
      padding: 15px 10px !important;
    }

    @include res(xl) {
      height: auto;
    }

    &:hover {
      color: $--color-grayscale-0;
    }
  }
}
</style>
